













import { Component, Prop, VModel } from "vue-property-decorator";
import PortalSelect from "@/components/common/PortalSelect.vue";
import CommonService from "@/services/CommonService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import SelectOption from "@/components/common/SelectOption";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import PRILExtension from "@/mixins/PRILExtension";

@Component<DictionarySelect>({
  components: { PortalSelect },
  inheritAttrs: false,
})
export default class DictionarySelect extends PRILExtension {
  @Prop({ default: null })
  groupName!: string | null

  @Prop({ default: false })
  allowAll!: boolean;

  @VModel({ type: Number })
  private dictId!: number | null;

  private dictionaries: Array<PortalDictionaryDTO> = [];

  mounted(): void {
    if (this.groupName) {
      Application.startLoading();
      CommonService.findByGroupName(this.groupName)
        .then(
          res => {
            const data = (res as any).data;
            if (Array.isArray(data)) {
              this.dictionaries = data;
            } else if (data && Array.isArray(data.data)) {
              this.dictionaries = data.data;
            } else if (data && Array.isArray(data.content)) {
              this.dictionaries = data.content;
            } else {
              this.dictionaries = [];
            }
            Application.stopLoading();
          },
          err => processError(err, this)
        );
    }
  }

  get buildDictionaries(): Array<SelectOption> {
    const opts = this.dictionaries.map(dictionary => SelectOption.builder().title(this.getDictionaryTitle(dictionary)).value(dictionary.id).build());
    if (this.allowAll) {
      return [SelectOption.builder().title("All").value(null).build(), ...opts];
    }
    return opts;
  }

}
